/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivAppraisalControllerFindAllParamsGen,
  MrfiktivAppraisalViewModelGen,
  MrfiktivCreateAppraisalDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateAppraisalDtoGen,
  MrfiktivUpdateAppraisalStatusDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Appraisal<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags appraisal
   * @name AppraisalControllerCreate
   * @summary Create a new appraisal
   * @request POST:/partners/{partnerId}/appraisals
   * @secure
   * @response `201` `MrfiktivAppraisalViewModelGen` The appraisal has been successfully created.
   */
  appraisalControllerCreate = (partnerId: string, data: MrfiktivCreateAppraisalDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivAppraisalViewModelGen, any>({
      path: `/partners/${partnerId}/appraisals`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal
   * @name AppraisalControllerFindAll
   * @summary Get all appraisals for a partner
   * @request GET:/partners/{partnerId}/appraisals
   * @secure
   * @response `200` `MrfiktivPageViewModelGen` List of appraisals
   */
  appraisalControllerFindAll = (
    { partnerId, ...query }: MrfiktivAppraisalControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen, any>({
      path: `/partners/${partnerId}/appraisals`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal
   * @name AppraisalControllerFindOne
   * @summary Get a specific appraisal
   * @request GET:/partners/{partnerId}/appraisals/{id}
   * @secure
   * @response `200` `MrfiktivAppraisalViewModelGen` The appraisal
   */
  appraisalControllerFindOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivAppraisalViewModelGen, any>({
      path: `/partners/${partnerId}/appraisals/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal
   * @name AppraisalControllerUpdate
   * @summary Update an appraisal
   * @request PATCH:/partners/{partnerId}/appraisals/{id}
   * @secure
   * @response `200` `MrfiktivAppraisalViewModelGen` The appraisal has been successfully updated.
   */
  appraisalControllerUpdate = (
    partnerId: string,
    id: string,
    data: MrfiktivUpdateAppraisalDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivAppraisalViewModelGen, any>({
      path: `/partners/${partnerId}/appraisals/${id}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal
   * @name AppraisalControllerRemove
   * @summary Delete an appraisal
   * @request DELETE:/partners/{partnerId}/appraisals/{id}
   * @secure
   * @response `200` `void` The appraisal has been successfully deleted.
   */
  appraisalControllerRemove = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partners/${partnerId}/appraisals/${id}`,
      method: "DELETE",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags appraisal
   * @name AppraisalControllerUpdateStatus
   * @summary (Appraisal - UPDATE) Update status of a clearance approval
   * @request PATCH:/partners/{partnerId}/appraisals/{id}/status
   * @secure
   * @response `200` `MrfiktivAppraisalViewModelGen` The updated clearance approval
   */
  appraisalControllerUpdateStatus = (
    partnerId: string,
    id: string,
    data: MrfiktivUpdateAppraisalStatusDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivAppraisalViewModelGen, any>({
      path: `/partners/${partnerId}/appraisals/${id}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
